import { TFunction } from "i18next";
import * as yup from "yup";

export interface FormOfTeachingValidationSchemeProps {
  t: TFunction;
}

export const FormOfTeachingValidationScheme = ({
  t,
}: FormOfTeachingValidationSchemeProps) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
      name: yup.string().required(requiredMsg)
  });;
};